import { first, clone, orderBy } from 'lodash';
import axios from 'axios';
import { speningOff, speningOn } from './spening';

export const getOrderById = async (orderId: string) => {
  const { data } = await axios.get(`/orders/${orderId}`);
  const order = first(data);
  return {
    type: 'UPDATE_ORDER',
    data: clone(order),
  };
};

export const updateOrderStore = (order: any) => {
  return {
    type: 'UPDATE_ORDER',
    data: order,
  };
};

export interface IApplyPromotion {
  order: any;
  promotionCode: string;
  cartProducts: any;
  sellerCode: string;
  totalAmount: number;
  totalDeliveryCost: number;
  userId: string;
}
export const applyPromotion = async (data: IApplyPromotion) => {
  speningOn();
  const jsonData = {
    code: data.promotionCode,
    cart: data.cartProducts,
    sellerId: data.sellerCode,
    totalAmount: data.totalAmount,
    totalDeliveryCost: data.totalDeliveryCost,
    userId: data.userId,
    channel: 'online',
  };
  const promotion = await axios
    .post(`/promotions/applyPromotion`, jsonData)
    .catch((error) => {
      return error.response.data.message;
    });

  if (promotion && promotion.data) {
    let gift = null;
    if (promotion.data.type === 'freegift') {
      const giftResponse = await axios.get(
        `/products/scg/detail/${promotion.data.giftProductCode}`
      );
      const giftName = giftResponse.data.productName;
      gift = {
        name: giftName,
        qty: promotion.data.giftProductQty,
      };
    }

    const shipmentDiscount = promotion.data.isFreeShipping
      ? 0
      : promotion.data.discountShipping || 0;

    const deliveryCost = promotion.data.isFreeShipping
      ? 0
      : data.order.deliveryCost;

    const totalPriceNet =
      data.order.totalPrice +
      deliveryCost -
      shipmentDiscount -
      (promotion.data.discountAmount || 0);

    const order = {
      ...data.order,
      promotionCode: data.promotionCode,
      promotionError: null,
      shipment_discount: shipmentDiscount,
      discount: promotion.data.discountAmount || 0,
      promotion_type: promotion.data.type,
      deliveryCost,
      totalPriceNet,
      gift,
    };

    speningOff();
    return updateOrderStore(order);
  } else {
    const order = {
      ...data.order,
      promotionCode: null,
      promotionError: promotion,
      shipment_discount: 0,
      discount: 0,
      promotion_type: null,
      gift: null,
    };

    speningOff();
    return updateOrderStore(order);
  }
};

export const saveOrder = async (order: any, formFields: any) => {
  speningOn();
  const dataOrders = {
    address: {
      address: formFields.address,
      city: formFields.city,
      postalCode: formFields.postalCode,
      state: formFields.state,
      subCity: formFields.subCity,
    },
    status: 'waiting_payment',
    totalPrice: order.totalPriceNet,
  };
  await axios.patch(`/orders/${order.order}`, dataOrders);

  const bodyCart = {
    userId: order.user,
    shops: [],
  };
  await axios.patch(`/carts/new-cart/${order.user}`, bodyCart);

  let promotionData = null;
  if (order.promotion_type !== '' && order.promotionCode) {
    const response = await axios.get(
      `/promotions/verify/${order.promotionCode}`
    );
    promotionData = response.data.data;
  }

  const time = formFields.shipmentTime.split('/');
  const deliveryTime = new Date(0, 0, 0, time[0], time[1], 0, 0);

  const dataOrderShop = {
    ...order,
    promotion: promotionData,
    totalPrice: order.totalPriceNet,
    status: 'waiting_payment',
    remark: formFields.remark ? formFields.remark : '',
    shipment: order.shipment ? order.shipment : 0,
    deliveryType: formFields.deliveryType
      ? formFields.deliveryType
      : '',
    shipmentDate: formFields.shipmentDate
      ? formFields.shipmentDate
      : '',
    shipmentTime: formFields.shipmentTime ? deliveryTime : '',
    shippingPrice: order.shippingPrice ? order.shippingPrice : '',
  };
  await axios.patch(`/ordershops/${order._id}`, dataOrderShop);

  if (order.promotion_type !== '' && order.promotionCode) {
    await axios.patch(`/promotions/redeem`, {
      code: order.promotionCode,
      userId: order.user,
      orderId: order.order,
    });
  }

  updateStockProduct(order);
  clearDataAfterPurchase(order.user);
  updateOrderStore({});
  speningOff();
};

const clearDataAfterPurchase = async (userId: string) => {
  await axios.delete(`/orders/delete/${userId}`);
  await axios.delete(`/ordershops/delete/${userId}`);
};

const updateStockProduct = async (order: any) => {
  const userProductsIdArray: any[] = [];
  order.products.map((product: any) => {
    const obj = {
      userProductId: product.product._id._id,
      newStock: product.product._id.stock - product.amount,
    };
    userProductsIdArray.push(obj);
    return obj;
  });

  if (userProductsIdArray.length) {
    for (let i = 0; i < userProductsIdArray.length; i++) {
      const dataOrderShop = {
        stock: userProductsIdArray[i].newStock,
        type: 'purchase',
      };
      await axios.patch(
        `/user-product/${userProductsIdArray[i].userProductId}`,
        dataOrderShop
      );
    }
  }
};
